import {  IPlanResult } from '../components/fintech-not-hired/types';
import { API_PATHS } from '../constants';
import { IContractValidationInfo } from '../types';
import FintechAPICaller, { ApiError } from './FintechAPICaller';
import { FintechContratoDTO, HireFintechResponseDTO } from './dtos/HireFintechResponseDTO';


export interface IContractValidationResult {
  contrato?: FintechContratoDTO;
  isValid: boolean;
  hasError: boolean;
  betaEndDate?: string;
  purchaseDate?: string;
  codParc?: string;
  externalContractId?: string;
  errorMsg?: string;
  contractedPlan?: IPlanResult;
  fintechClientId?: string;
}

class FintechContractValidation {
  /**
   * A API chamada em hireFintech retorna um contrato ativo existente ou, 
   * na ausência dele, valida e efetiva uma pré-contratação disponível.
   */
  public static async validateFintechContract(contractValidationInfo: IContractValidationInfo): Promise<IContractValidationResult> {
    const codParc = contractValidationInfo.code;

    const hireResult = await this.hireFintech(contractValidationInfo);

    return { ...hireResult, codParc };
  }

  private static async hireFintech(contractValidationInfo: IContractValidationInfo): Promise<IContractValidationResult> {
    const MAX_TRIES = 3;
    let tries = 0;

    const requestBody = {
      cliente: {
        idExterno: contractValidationInfo.code,
        nome: contractValidationInfo.name,
      },
    };

    while (tries <= MAX_TRIES) {
      try {
        const {data} = await FintechAPICaller.post<HireFintechResponseDTO>({
          servicePath: API_PATHS.HIRE_FINTECH,
          data: requestBody,
          params: { categoria: contractValidationInfo.plano_categoria || 'DEFAULT' },
        });
        if (data?.contrato) {
          const {contrato, cliente} = data;
          const hasService = !contractValidationInfo.servico ? true : contrato.planoContratado.servicos.some(service => service.id === contractValidationInfo.servico);
          return {
            contrato,
            isValid: hasService,
            betaEndDate: contrato.dataFimBeta,
            purchaseDate: contrato.dataAtivacao,
            externalContractId: contrato.idExternoContrato,
            contractedPlan: {
              id: contrato.id,
              idMktpPlan: contrato.planoContratado.idContratoMktp,
              packName: contrato.planoContratado.nome,
              services: contrato.planoContratado.servicos.map(servico => ({
                id: servico.id,
              })),
            },
            fintechClientId: cliente.id,
            hasError: false,
          };
        }

        tries++;
        if (tries < MAX_TRIES) {
          await new Promise(resolve => setTimeout(resolve, 5000));
        }
      } catch (e: unknown) {
        const error = e as ApiError;
        const hasError = error?.code !== 404;
        const errorMsg = hasError ? error.message : undefined;
        return { isValid: false, errorMsg, hasError }; 
      }
    }

    return { isValid: false, hasError: true };
  }
  
}

export default FintechContractValidation;
